export const NAME = 'Provozovna';
export const CRUMB_LABEL_KEY = 'Provozovna';
export { DMS_MODULE } from '../constants';

export const TAB_NAMES = <const>{
	UDAJE_O_FIRME: 'UdajeOFirme',
	FIRMA_NASTAVENI_1: 'Fn1',
	FIRMA_NASTAVENI_2: 'Fn2',
	APLIKACE_NASTAVENI: 'AplikaceNastaveni',
	GRAF_LOGA: 'GrafLoga',
	SERVISNI_PERSONAL: 'ServPersProvoz',
	CERT_SPEC_OPRAV: 'SpecialistaNehody',
	FLEET_CENTRUM: 'FleetCentrum',
	PLANNER: 'Planner',
	BANKA1: 'Banka1',
	BANKA2: 'Banka2',
	TELMOBNR: 'TelmobNr',
	FAXNR: 'FaxNr',
	TELSMNR: 'TelsmNr',
	TELNVNR: 'TelnvNr',
	TELOVNR: 'TelovNr',
	TELSKLADNR: 'TelskladNr',
};

export const PlannerStartingTime = '06:00';
export const PlannerEndingTime = '23:30';
export const PlannerStepInterval = '00:05';

export const TABS = {
	[TAB_NAMES.UDAJE_O_FIRME]: { id: TAB_NAMES.UDAJE_O_FIRME, labelKey: 'nastaveniTab0' },
	[TAB_NAMES.FIRMA_NASTAVENI_1]: { id: TAB_NAMES.FIRMA_NASTAVENI_1, labelKey: 'FN1' },
	[TAB_NAMES.FIRMA_NASTAVENI_2]: { id: TAB_NAMES.FIRMA_NASTAVENI_2, labelKey: 'FN2' },
	[TAB_NAMES.APLIKACE_NASTAVENI]: { id: TAB_NAMES.APLIKACE_NASTAVENI, labelKey: 'ApNas' },
	[TAB_NAMES.GRAF_LOGA]: { id: TAB_NAMES.GRAF_LOGA, labelKey: 'Graf. Loga' },
	[TAB_NAMES.SERVISNI_PERSONAL]: { id: TAB_NAMES.SERVISNI_PERSONAL, labelKey: 'tsServPers' },
	[TAB_NAMES.CERT_SPEC_OPRAV]: { id: TAB_NAMES.CERT_SPEC_OPRAV, labelKey: 'tbCertSpecOprav' },
	[TAB_NAMES.FLEET_CENTRUM]: { id: TAB_NAMES.FLEET_CENTRUM, labelKey: 'tsFleetCentrum' },
	[TAB_NAMES.PLANNER]: { id: TAB_NAMES.PLANNER, labelKey: 'tsPlannerSetting' },
};

export const TABS2 = {
	[TAB_NAMES.BANKA1]: { id: TAB_NAMES.BANKA1, labelKey: 'Banka1' },
	[TAB_NAMES.BANKA2]: { id: TAB_NAMES.BANKA2, labelKey: 'Banka2' },
};

export const TABS3 = {
	[TAB_NAMES.TELMOBNR]: { id: TAB_NAMES.TELMOBNR, labelKey: 'mobilNrTab' },
	[TAB_NAMES.FAXNR]: { id: TAB_NAMES.FAXNR, labelKey: 'faxNrTab' },
	[TAB_NAMES.TELSMNR]: { id: TAB_NAMES.TELSMNR, labelKey: 'smNrTab' },
	[TAB_NAMES.TELNVNR]: { id: TAB_NAMES.TELNVNR, labelKey: 'nvNrTab' },
	[TAB_NAMES.TELOVNR]: { id: TAB_NAMES.TELOVNR, labelKey: 'ovNrTab' },
	[TAB_NAMES.TELSKLADNR]: { id: TAB_NAMES.TELSKLADNR, labelKey: 'skladNrTab' },
};
